import { SlideIcon } from './SlideIcon';

/**
 * author: Michael Irigoyen
 * id 799D9561-AC12-4E30-8CA8-2FBF9E5597B8
 * name slide
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/slide.svg
 * tags
 */
export const PlaygroundSlideIcon = SlideIcon;
export default PlaygroundSlideIcon